import {
  ARC_INNER_RADIUS_PERCENTAGE,
  ARC_OUTER_RADIUS_PERCENTAGE,
} from '../constants.js';
import { useGaugeChartSizeContext } from './useGaugeChartSizeContext.js';

export const useGaugeChartAspectRatio = (): {
  arcOuterRadius: number;
  arcInnerRadius: number;
  arcMiddleRadius: number;
} => {
  const dimensions = useGaugeChartSizeContext();
  const width = dimensions?.width;
  const height = dimensions?.height;

  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const radius = Math.min(width!, height!) / 2;

  const arcOuterRadius = radius * ARC_OUTER_RADIUS_PERCENTAGE;

  const arcInnerRadius = radius * ARC_INNER_RADIUS_PERCENTAGE;

  const arcMiddleRadius =
    arcInnerRadius + (arcOuterRadius - arcInnerRadius) / 2;

  return {
    arcOuterRadius,
    arcInnerRadius,
    arcMiddleRadius,
  };
};
